import { app_psnl_menu_node_hdr_RowClass, app_psnl_menu_node_hdr_RowInterface } from "../../dbschema/app_psnl_menu_node_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class PersonalMenuNodeHdrContainer extends BaseContainerModel {
  app_psnl_menu_node_hdr: app_psnl_menu_node_hdr_RowInterface = new app_psnl_menu_node_hdr_RowClass();
}